import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from "recharts";
import { Card } from "react-bootstrap";

const GraficoOrdiniFornitori = () => {
  const [dataGrafico, setDataGrafico] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((json) => {
        const ordiniRaw = json?.ORDINI_URGENTI?.flat() || [];

        const raggruppati = ordiniRaw
          .filter(item => item["Tipo Riga"] === "T")
          .reduce((acc, curr) => {
            const nome = curr["Ragione sociale"] || "Sconosciuto";
            const importo = parseFloat(curr["Importo"]) || 0;
            acc[nome] = (acc[nome] || 0) + importo;
            return acc;
          }, {});

        const formattedData = Object.keys(raggruppati)
          .map((key) => ({
            name: key,
            totaleImporto: parseFloat(raggruppati[key].toFixed(2)),
          }))
          .sort((a, b) => b.totaleImporto - a.totaleImporto)
          .slice(0, 10); // <--- SOLO I TOP 10

        setDataGrafico(formattedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch grafico:", err);
        setLoading(false);
      });
  }, []);

  const formatXAxis = (tickItem) => {
    return tickItem.length > 12 ? `${tickItem.substring(0, 12)}...` : tickItem;
  };

  if (loading) return <div className="text-center p-5 text-muted">Caricamento grafico in corso...</div>;

  return (
    <Card className="border-0 card shadow-lg  overflow-hidden" style={{ borderRadius: '15px', height: '400px' }}>
      <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-bold text-secondary" style={{ letterSpacing: '0.5px' }}>
          TOP 10 FORNITORI - ORDINI URGENTI
        </h6>
        <span className="badge rounded-pill bg-danger shadow-sm">Live</span>
      </div>
      
      <div className="p-2 flex-grow-1" style={{ height: '320px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={dataGrafico}
            margin={{ top: 20, right: 30, left: 10, bottom: 60 }}
          >
            {/* Definiamo un gradiente per le barre */}
            <defs>
              <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#b81f25" stopOpacity={0.9}/>
                <stop offset="95%" stopColor="#8b181d" stopOpacity={1}/>
              </linearGradient>
            </defs>

            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
            
            <XAxis 
              dataKey="name" 
              tickFormatter={formatXAxis}
              interval={0} 
              angle={-40} 
              textAnchor="end"
              style={{ fontSize: '11px', fontWeight: '500', fill: '#6c757d' }}
              dy={10}
            />
            
            <YAxis 
              tickFormatter={(value) => `€${value.toLocaleString()}`} 
              style={{ fontSize: '11px', fill: '#6c757d' }}
              axisLine={false}
              tickLine={false}
            />
            
            <Tooltip 
              cursor={{ fill: '#f8f9fa' }}
              formatter={(value) => [`€ ${value.toLocaleString()}`, 'Importo Totale']}
              contentStyle={{ 
                borderRadius: '12px', 
                border: 'none', 
                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                padding: '10px' 
              }}
              itemStyle={{ fontWeight: 'bold', color: '#b81f25' }}
            />
            
            <Bar 
              dataKey="totaleImporto" 
              fill="url(#barGradient)"
              radius={[6, 6, 0, 0]} // Arrotonda gli angoli superiori
              barSize={35}
            >
              {dataGrafico.map((entry, index) => (
                <Cell key={`cell-${index}`} fillOpacity={1 - index * 0.05} /> 
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default GraficoOrdiniFornitori;